import { FieldArray, Formik } from "formik";
import { useEffect, useState } from "react";
import Spin from "../../components/Spin";
import {
  API,
  fileUpload,
  PayeePayeerOptions,
  paymentMethods,
  taxOptions,
} from "../../config";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Loader2, Plus, Trash2 } from "lucide-react";
import CustomLabelText from "../../components/CustomLabelText";
// import { cn } from "../../lib/utils";
// import ReactInputMask from "react-input-mask";
import { Textarea } from "../../components/ui/textarea";
import { DateInputPicker } from "../../components/DateInputPicker";
import { useMediaQuery } from "../../components/use-media-query";
import VendorSelect from "../../components/VendorSelect";
import {
  CalculateAmountExcGST,
  CalculateGST,
  // formatBSBNumber,
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import ContactSelect from "../../components/ContactSelect";
// import JobSelect from "../../components/JobSelect";
// import TaskSelect from "../../components/TaskSelect";
import AssetSelect from "../../components/AssetSelect";
import SubAssetSelect from "../../components/SubAssetSelect";
import { AddReceiptSchema } from "../../lib/Validation";
import SearchSelect from "../../components/SearchSelect";
import ContractSelect from "../../components/ContractSelect";
import moment from "moment";
import Confirmation from "../../components/Confirmation";
import { Checkbox } from "../../components/ui/checkbox";
import CustomTooltip from "../../components/CustomTooltip";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import { useOrganization } from "../../lib/context/OrganisationContext";
import JobSelect from "../../components/JobSelect";
import TaskSelect from "../../components/TaskSelect";
import { LawyerConditon } from "../../lib/PermissionConditions";
// import ChartOfAccountSelect from "../../components/ChartOfAccountSelect";

const AddEditReceipt = ({
  id,
  toggleShowAddEditReceipt,
  edit,
  fetchReceiptData,
  trustId,
  receiptLastDate,
  popupType = false,
}) => {
  const { organizationData } = useOrganization();
  const [loading, setLoading] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorListing, setVendorListing] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const [contactLoading, setContactLoading] = useState(false);
  const [contactListing, setContactListing] = useState([]);
  const [contactList, setContactList] = useState([]);

  // const [jobLoading, setJobLoading] = useState(false);
  // const [jobListing, setJobListing] = useState([]);
  // const [jobList, setJobList] = useState([]);

  // const [taskLoading, setTaskLoading] = useState(false);
  // const [taskListing, setTaskListing] = useState([]);
  // const [taskList, setTaskList] = useState([]);

  const [listingHelper, setListingHelper] = useState([
    {
      asset: {
        listing: [],
        loading: false,
      },
      sub_asset: {
        listing: [],
        loading: false,
      },
      contract: {
        listing: [],
        loading: false,
      },
      beneficiary: {
        listing: [],
        loading: false,
      },
      job: {
        listing: [],
        loading: false,
      },
      task: {
        listing: [],
        loading: false,
      },
    },
  ]);

  const [sendEmailModal, setSendEmailModal] = useState(false);

  const fromInitalDate = receiptLastDate
    ? new Date(
        `${receiptLastDate?.split("-")[2]}-${receiptLastDate?.split("-")[1]}-${
          receiptLastDate?.split("-")[0]
        }`,
      )
    : "";
  receiptLastDate && fromInitalDate.setDate(fromInitalDate.getDate() + 1);

  const toggleSendEmailModal = () => {
    setSendEmailModal(!sendEmailModal);
  };

  const handleFormSubmit = async (values) => {
    const formData = new FormData();

    formData.append("trust_id", trustId);

    formData.append(
      "transaction_date",
      moment(
        values?.transaction_date ? values?.transaction_date : new Date(),
      ).format("DD-MM-YYYY"),
    );

    formData.append(
      "received_date",
      moment(values?.received_date ? values?.received_date : new Date()).format(
        "DD-MM-YYYY",
      ),
    );
    formData.append("file_note", values?.file_note);
    formData.append("invoice_number", values?.invoice_number);

    formData.append("payeer", values?.payeer);

    if (values?.contact_id) {
      formData.append("contact_id", values?.contact_id);
    }

    if (values?.vendor_id) {
      formData.append("vendor_id", values?.vendor_id);
    }

    formData.append("payment_method", values?.payment_method);

    formData.append(`refund`, values?.refund ? 1 : 0);

    formData.append("send_email", values?.send_email);

    formData.append(
      "total_amount_exc",
      values?.receipts
        ?.flatMap((receipt) => receipt.receipt_data)
        ?.reduce(
          (sum, item) => sum + Number(`${item?.amount}`.replace(/,/g, "")),
          0,
        )
        .toFixed(2),
    );

    formData.append(
      "total_amount",
      values?.receipts
        ?.flatMap((receipt) => receipt.receipt_data)
        ?.reduce(
          (sum, item) =>
            sum + Number(`${item?.total_amount}`.replace(/,/g, "")),
          0,
        )
        .toFixed(2),
    );

    formData.append(
      "total_tax_amount",
      values?.receipts
        ?.flatMap((receipt) => receipt.receipt_data)
        ?.reduce(
          (sum, item) => sum + Number(`${item?.tax_amount}`.replace(/,/g, "")),
          0,
        )
        .toFixed(2),
    );

    // Append receipt_data array items
    values?.receipts.forEach((receipt, i) => {
      formData.append(`receipts[${i}][tax]`, receipt?.tax ? receipt?.tax : "1");
      formData.append(
        `receipts[${i}][contract_id]`,
        receipt?.contract_id ? receipt?.contract_id : "",
      );
      formData.append(
        `receipts[${i}][vendor_id]`,
        receipt?.vendor_id ? receipt?.vendor_id : "",
      );
      formData.append(
        `receipts[${i}][asset_id]`,
        receipt?.asset_id ? receipt?.asset_id : "",
      );
      formData.append(
        `receipts[${i}][sub_asset_id]`,
        receipt?.sub_asset_id ? receipt?.sub_asset_id : "",
      );

      formData.append(
        `receipts[${i}][ts_job_id]`,
        receipt?.ts_job_id ? receipt?.ts_job_id : "",
      );

      formData.append(
        `receipts[${i}][ts_task_id]`,
        receipt?.ts_task_id ? receipt?.ts_task_id : "",
      );

      receipt?.receipt_data.forEach((item, index) => {
        for (const key in item) {
          let value = item[key];

          if (key === "from" || key === "to") {
            value = value ? moment(value).format("DD-MM-YYYY") : "";
            formData.append(
              `receipts[${i}][receipt_data][${index}][${key}]`,
              value,
            );
          } else if (key === "amount") {
            formData.append(
              `receipts[${i}][receipt_data][${index}][amount_exc]`,
              value ? value : "",
            );
          } else if (key === "total_amount") {
            formData.append(
              `receipts[${i}][receipt_data][${index}][amount]`,
              value ? value : "",
            );
          } else {
            formData.append(
              `receipts[${i}][receipt_data][${index}][${key}]`,
              value,
            );
          }
        }
      });
    });

    if (edit) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.CREATE_RECEIPT}${edit ? `/${id}` : ""}`,
        formData,
      );
      setLoading(false);
      if (data) {
        toggleShowAddEditReceipt();
        fetchReceiptData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };

  const initialValues = {
    received_date: "",
    transaction_date: "",
    file_note: "",
    invoice_number: "",
    payeer: "contact",
    contact_id: "",
    vendor_id: "",
    payment_method: 1,
    refund: true,
    receipts: [
      {
        vendor_id: "",
        asset_id: "",
        sub_asset_id: "",
        contract_id: "",
        ts_job_id: "",
        ts_task_id: "",
        receipt_data: [
          {
            from: fromInitalDate,
            to: "",
            amount: "",
            total_amount: "",
            tax_amount: "",
            // payment_method: 1,
            description: "",
          },
        ],
      },
    ],
  };

  useEffect(() => {
    if (vendorList) {
      let vendorTempListing = vendorList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setVendorListing(vendorTempListing || []);
    } else {
      setVendorListing([]);
    }
  }, [vendorList]);

  // useEffect(() => {
  //   if (chartOfAccountList) {
  //     let chartOfAccountTempListing = chartOfAccountList?.map((item) => ({
  //       ...item,
  //       value: item?.id,
  //       label: `${item.name} ${
  //         item.code
  //           ? `(${item.code}${item.sub_code ? `.${item.sub_code}` : ""})`
  //           : ""
  //       }`,
  //     }));
  //     setChartOfAccountListing(chartOfAccountTempListing || []);
  //   } else {
  //     setChartOfAccountListing([]);
  //   }
  // }, [chartOfAccountList]);

  useEffect(() => {
    if (contactList) {
      let contactTempListing = contactList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setContactListing(contactTempListing || []);
    } else {
      setContactListing([]);
    }
  }, [contactList]);

  // useEffect(() => {
  //   if (jobList) {
  //     let jobTempListing = jobList?.map((item) => ({
  //       ...item,
  //       value: item.id,
  //       label: `${item?.title} ${item?.code ? `(${item?.code})` : ""}`,
  //     }));
  //     setJobListing(jobTempListing || []);
  //   } else {
  //     setJobListing([]);
  //   }
  // }, [jobList]);

  // useEffect(() => {
  //   if (taskList) {
  //     let taskTempListing = taskList?.map((item) => ({
  //       ...item,
  //       value: item.id,
  //       label: `${item?.title} ${item?.code ? `(${item?.code})` : ""}`,
  //     }));
  //     setTaskListing(taskTempListing || []);
  //   } else {
  //     setTaskListing([]);
  //   }
  // }, [taskList]);

  // eslint-disable-next-line no-unused-vars
  const checkVendorBankDetailsForReceipts = (values) => {
    return vendorListing?.length > 0 && values?.refund === false
      ? values?.receipts?.find(
          (receiptItem) =>
            !vendorListing?.find(
              (item) => item.value === receiptItem?.vendor_id,
            )?.bank_id,
        )
        ? true
        : false
      : false;
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={false}
      validateOnChange={true}
      validationSchema={AddReceiptSchema(organizationData)}
      isInitialValid={false}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setTouched,
        validateField,
        isValid,
        submitForm,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box flex max-h-[78vh] bg-muted flex-col gap-4 overflow-y-auto overflow-x-hidden p-2 border rounded-lg">
              <div className="border bg-background rounded-md p-2 shadow-sm space-y-2 flex w-full items-center flex-wrap">
                <div className="flex-1 flex items-center gap-2 flex-wrap">
                  <div className="grid gap-2">
                    <Label htmlFor="file_note">
                      <CustomLabelText
                        required={true}
                        labelText="Received Date"
                        errorField={errors?.received_date}
                      />
                    </Label>
                    <DateInputPicker
                      date={
                        values?.received_date
                          ? values?.received_date
                          : new Date()
                      }
                      onSelect={(e) => {
                        setFieldValue("received_date", e);
                        setFieldValue("transaction_date", e);
                      }}
                      className={"text-left"}
                      icon={false}
                      disabledDate={{ after: new Date() }}
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="file_note">
                      <CustomLabelText
                        required={true}
                        labelText="Transaction Date"
                        errorField={errors?.transaction_date}
                      />
                    </Label>
                    <DateInputPicker
                      date={
                        values?.transaction_date
                          ? values?.transaction_date
                          : new Date()
                      }
                      onSelect={(e) => {
                        setFieldValue("transaction_date", e);
                      }}
                      className={"text-left"}
                      icon={false}
                      disabledDate={{ after: new Date() }}
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="file_note">
                      <CustomLabelText
                        required={false}
                        // labelText="File Note"
                        labelText={
                          LawyerConditon(organizationData)
                            ? "Matter Reference"
                            : "File Note"
                        }
                        errorField={errors?.file_note}
                        bottomAlign={true}
                      />
                    </Label>
                    <Input
                      type="text"
                      name="file_note"
                      value={values?.file_note ? values?.file_note : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.file_note &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="invoice_number">
                      <CustomLabelText
                        required={false}
                        labelText="Invoice Number"
                        errorField={errors?.invoice_number}
                        bottomAlign={true}
                      />
                    </Label>
                    <Input
                      type="text"
                      name="invoice_number"
                      value={
                        values?.invoice_number ? values?.invoice_number : ""
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.invoice_number &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2">
                    <div className="min-w-0">
                      <Label htmlFor="payeer">
                        <CustomLabelText
                          required={true}
                          labelText="Payer"
                          errorField={errors?.payeer}
                        />
                      </Label>
                      <div className="relative mt-2">
                        <SearchSelect
                          frameworks={PayeePayeerOptions(organizationData)}
                          optionType={"Payeer"}
                          handleSelect={(e) => {
                            setFieldValue(`payeer`, e);
                            setFieldValue("contact_id", "");
                            setFieldValue("vendor_id", "");
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.payeer &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={false}
                          initialValue={values?.payeer}
                        />
                      </div>
                    </div>
                  </div>

                  {values?.payeer === "vendor" ? (
                    <div className="grid gap-2">
                      <div className="w-[215px]">
                        <Label htmlFor="vendor_id">
                          <CustomLabelText
                            labelText={getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "vendors",
                              "Vendor",
                            )}
                            errorField={errors?.vendor_id}
                            required={true}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <VendorSelect
                            trustId={trustId}
                            frameworkData={vendorListing} // List of vendors
                            optionType={getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "vendors",
                              "Vendor",
                            )}
                            handleSelect={(e) => {
                              setFieldValue(`vendor_id`, e);
                              setFieldValue(`receipts`, [
                                {
                                  vendor_id: e,
                                  asset_id: "",
                                  sub_asset_id: "",
                                  contract_id: "",
                                  ts_job_id: "",
                                  ts_task_id: "",
                                  receipt_data: [
                                    {
                                      from: fromInitalDate,
                                      to: "",
                                      amount: "",
                                      total_amount: "",
                                      tax_amount: "",
                                      // payment_method: 1,
                                      description: "",
                                    },
                                  ],
                                },
                              ]);
                              setListingHelper([
                                {
                                  asset: {
                                    listing: [],
                                    loading: false,
                                  },
                                  sub_asset: {
                                    listing: [],
                                    loading: false,
                                  },
                                  contract: {
                                    listing: [],
                                    loading: false,
                                  },
                                  beneficiary: {
                                    listing: [],
                                    loading: false,
                                  },
                                  job: {
                                    listing: [],
                                    loading: false,
                                  },
                                  task: {
                                    listing: [],
                                    loading: false,
                                  },
                                },
                              ]);
                            }}
                            name="vendor_id"
                            disabled={false}
                            initialValue={
                              values?.vendor_id ? values?.vendor_id : ""
                            }
                            setVendorList={setVendorList} // Update vendor list as new data loads
                            setVendorLoading={setVendorLoading} // Control loading state
                            onClear={() => {
                              setFieldValue(`vendor_id`, "");
                            }}
                            className={
                              errors?.vendor_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            loading={vendorLoading}
                          />
                          {vendorLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="grid gap-2">
                      <div className="w-[215px]">
                        <Label htmlFor="contact_id">
                          <CustomLabelText
                            labelText={getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "contacts",
                              "Customer",
                            )}
                            errorField={errors?.contact_id}
                            required={true}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <ContactSelect
                            trustId={trustId}
                            frameworkData={contactListing} // List of vendors
                            optionType={getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "contacts",
                              "Customer",
                            )}
                            handleSelect={(e) => {
                              setFieldValue(`contact_id`, e);
                            }}
                            name="contact_id"
                            disabled={false}
                            initialValue={
                              values?.contact_id ? values?.contact_id : ""
                            }
                            setContactList={setContactList} // Update vendor list as new data loads
                            setContactLoading={setContactLoading} // Control loading state
                            onClear={() => {
                              setFieldValue(`contact_id`, "");
                            }}
                            className={
                              errors?.contact_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            loading={contactLoading}
                          />
                          {contactLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="grid gap-2">
                    <div className="min-w-0">
                      <Label htmlFor="base_type">
                        <CustomLabelText
                          required={true}
                          labelText="Payment Method"
                          errorField={errors?.payment_method}
                        />
                      </Label>
                      <div className="relative mt-2">
                        <SearchSelect
                          frameworks={paymentMethods}
                          optionType={"Payment Method"}
                          handleSelect={(e) => {
                            setFieldValue(`payment_method`, e);
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.payment_method &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={false}
                          initialValue={values?.payment_method}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="grid gap-2">
                    <div className="min-w-0">
                      <div className="relative mt-7">
                        <div className="flex items-center space-x-2 mt-4">
                          <Checkbox
                            id="terms"
                            checked={values?.refund}
                            name="refund"
                            onClick={() => {
                              setFieldValue("refund", !values?.refund);
                            }}
                          />
                          <label
                            htmlFor="terms"
                            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 flex items-center gap-2"
                          >
                            Refundable Deposit
                            <CustomTooltip
                              message={
                                "General ledger entry will be posted to customer account (not vendor)"
                              }
                              leftAlign={true}
                            >
                              <InfoCircledIcon className="text-webPrimary" />
                            </CustomTooltip>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-webPrimary text-white text-sm px-2 rounded-md">
                  Receipt Total: $
                  {values?.receipts
                    ?.flatMap((receipt) => receipt.receipt_data)
                    ?.reduce(
                      (sum, item) =>
                        sum + Number(`${item?.total_amount}`.replace(/,/g, "")),
                      0,
                    )
                    ? formatNumber(
                        values?.receipts
                          ?.flatMap((receipt) => receipt.receipt_data)
                          ?.reduce(
                            (sum, item) =>
                              sum +
                              Number(`${item?.total_amount}`.replace(/,/g, "")),
                            0,
                          ),
                      )
                    : "0.00"}
                </div>
              </div>
              <FieldArray name="receipts">
                {({ push, remove }) => (
                  <>
                    {values.receipts.map((receipt, pIndex) => (
                      <div className="border bg-background rounded-md p-2 shadow-sm space-y-2">
                        <div className="flex justify-between items-center">
                          <h4 className="font-semibold">Receipt</h4>

                          <div className="flex items-center gap-2">
                            {receipt?.sub_asset_id && (
                              <>
                                <div className="bg-webPrimary text-white text-sm px-2 rounded-md">
                                  Balance (Inc):{" "}
                                  {listingHelper[
                                    pIndex
                                  ]?.sub_asset?.listing?.find(
                                    (item) =>
                                      item?.id === receipt?.sub_asset_id,
                                  )?.receipt_details_total
                                    ? `$${formatNumber(
                                        Number(
                                          listingHelper[
                                            pIndex
                                          ]?.sub_asset?.listing?.find(
                                            (item) =>
                                              item?.id ===
                                              receipt?.sub_asset_id,
                                          )?.receipt_details_total,
                                        ),
                                      )}`
                                    : "$0.00"}
                                </div>
                                <div className="bg-green-500 text-white text-sm px-2 rounded-md">
                                  Balance After Receipt (Inc):{" "}
                                  {formatNumber(
                                    receipt?.receipt_data?.reduce(
                                      (sum, p) =>
                                        sum +
                                        Number(
                                          `${p?.total_amount}`.replace(
                                            /,/g,
                                            "",
                                          ),
                                        ),
                                      0,
                                    ),
                                  )
                                    ? `$${formatNumber(
                                        Number(
                                          listingHelper[
                                            pIndex
                                          ]?.sub_asset?.listing?.find(
                                            (item) =>
                                              item?.id ===
                                              receipt?.sub_asset_id,
                                          )?.receipt_details_total,
                                        ) +
                                          Number(
                                            receipt?.receipt_data?.reduce(
                                              (sum, p) =>
                                                sum +
                                                Number(
                                                  `${p?.total_amount}`.replace(
                                                    /,/g,
                                                    "",
                                                  ),
                                                ),
                                              0,
                                            ),
                                          ),
                                      )}`
                                    : `$0.00`}
                                </div>
                              </>
                            )}
                            {/* {pIndex + 1 === values?.receipts?.length && (
                              <Button
                                type="button"
                                size="icon"
                                onClick={() => {
                                  push({
                                    vendor_id: "",
                                    asset_id: "",
                                    sub_asset_id: "",
                                    contract_id: "",
                                    ts_job_id: "",
                                    ts_task_id: "",
                                    receipt_data: [
                                      {
                                        from: fromInitalDate,
                                        to: "",
                                        amount: "",
                                        total_amount: "",
                                        tax_amount: "",
                                        // payment_method: 1,
                                        description: "",
                                      },
                                    ],
                                  });

                                  setListingHelper((pre) => [
                                    ...pre,
                                    {
                                      asset: {
                                        listing: [],
                                        loading: false,
                                      },
                                      sub_asset: {
                                        listing: [],
                                        loading: false,
                                      },
                                      contract: {
                                        listing: [],
                                        loading: false,
                                      },
                                      job: {
                                        listing: [],
                                        loading: false,
                                      },
                                      task: {
                                        listing: [],
                                        loading: false,
                                      },
                                    },
                                  ]);
                                }}
                                className="h-6 w-6"
                              >
                                <Plus className="h-4 w-4" />
                              </Button>
                            )}
                            {values?.receipts?.length > 1 && (
                              <>
                                {pIndex + 1 === values?.receipts?.length && (
                                  <span>/</span>
                                )}
                                <Button
                                  type="button"
                                  variant="destructive"
                                  size="icon"
                                  onClick={() => {
                                    remove(pIndex);

                                    setListingHelper((prev) =>
                                      prev.filter(
                                        (_, index) => index !== pIndex
                                      )
                                    );
                                  }}
                                  className="h-6 w-6"
                                >
                                  <Trash2 className="h-4 w-4" />
                                </Button>
                              </>
                            )} */}
                          </div>
                        </div>

                        {/* Receipt Info Fields */}
                        <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-4">
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="sub_asset_id">
                                <CustomLabelText
                                  labelText={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "sub-assets",
                                    "Sub Asset",
                                  )}
                                  errorField={
                                    errors?.receipts?.[pIndex]?.sub_asset_id
                                  }
                                  required={true}
                                />
                              </Label>
                              {values?.contact_id || values?.vendor_id ? (
                                <div className="relative mt-2">
                                  {console.log(values)}
                                  <SubAssetSelect
                                    trustId={trustId}
                                    assetId={""}
                                    contactId={""}
                                    vendorId={
                                      values?.payeer === "vendor"
                                        ? values?.vendor_id
                                          ? values?.vendor_id
                                          : ""
                                        : ""
                                    }
                                    frameworkData={
                                      listingHelper[pIndex]?.sub_asset?.listing
                                        ? listingHelper[pIndex]?.sub_asset
                                            ?.listing
                                        : []
                                    } // List of vendors
                                    optionType={getModuleNamingBySlug(
                                      organizationData?.organizationData,
                                      "sub-assets",
                                      "Sub Asset",
                                    )}
                                    handleSelect={(e) => {
                                      let subAssetData = listingHelper[
                                        pIndex
                                      ]?.sub_asset?.listing?.find(
                                        (item) => item.value === e,
                                      );
                                      setFieldValue(
                                        `receipts.${pIndex}.tax_percentage`,
                                        subAssetData?.tax_percentage,
                                      );
                                      setFieldValue(
                                        `receipts.${pIndex}.tax`,
                                        subAssetData?.tax_type,
                                      );
                                      setFieldValue(
                                        `receipts.${pIndex}.sub_asset_id`,
                                        e,
                                      );
                                      setFieldValue(
                                        `receipts.${pIndex}.contract_id`,
                                        "",
                                      );

                                      // setTimeout(() => {
                                      //   setTouched(
                                      //     {
                                      //       [`receipts.${pIndex}.sub_asset_id`]: true,
                                      //     },
                                      //     true
                                      //   );
                                      //   validateField(
                                      //     `receipts.${pIndex}.sub_asset_id`
                                      //   );
                                      // }, 0);
                                      let totalAmount = receipt?.receipt_data[0]
                                        ?.total_amount
                                        ? receipt?.receipt_data[0]?.total_amount
                                        : "";

                                      let gst_price = CalculateGST(
                                        "1",
                                        receipt?.tax,
                                        totalAmount,
                                        subAssetData?.tax_percentage,
                                      );

                                      let amount_inc = CalculateAmountExcGST(
                                        "1",
                                        receipt?.tax,
                                        totalAmount,
                                        subAssetData?.tax_percentage,
                                      );

                                      receipt?.receipt_data?.length > 0 &&
                                        setFieldValue(
                                          `receipts.${pIndex}.receipt_data.${0}.total_amount`,
                                          totalAmount,
                                        );

                                      receipt?.receipt_data?.length > 0 &&
                                        setFieldValue(
                                          `receipts.${pIndex}.receipt_data.${0}.amount`,
                                          amount_inc,
                                        );

                                      receipt?.receipt_data?.length > 0 &&
                                        setFieldValue(
                                          `receipts.${pIndex}.receipt_data.${0}.tax_amount`,
                                          gst_price,
                                        );

                                      setFieldValue(
                                        `receipts.${pIndex}.asset_id`,
                                        subAssetData?.asset_id,
                                      );
                                      setListingHelper((prev) =>
                                        prev.map((item, index) =>
                                          index === pIndex
                                            ? {
                                                ...item,
                                                asset: {
                                                  ...item.asset,
                                                  listing: [
                                                    {
                                                      ...subAssetData?.asset,
                                                      label: subAssetData?.asset
                                                        ?.name
                                                        ? subAssetData?.asset
                                                            ?.name
                                                        : "",
                                                      value:
                                                        subAssetData?.asset_id
                                                          ? subAssetData?.asset_id
                                                          : "",
                                                    },
                                                  ],
                                                },
                                              }
                                            : item,
                                        ),
                                      );

                                      setFieldValue(
                                        `receipts.${pIndex}.vendor_id`,
                                        subAssetData?.vendor_id,
                                      );

                                      setListingHelper((prev) =>
                                        prev.map((item, index) =>
                                          index === pIndex
                                            ? {
                                                ...item,
                                                contract: {
                                                  ...item.contract,
                                                  listing: [],
                                                },
                                              }
                                            : item,
                                        ),
                                      );
                                    }}
                                    name="sub_asset_id"
                                    // disabled={values?.asset_id ? false : true}
                                    disabled={false}
                                    initialValue={
                                      receipt?.sub_asset_id
                                        ? receipt?.sub_asset_id
                                        : ""
                                    }
                                    setListingHelper={setListingHelper}
                                    targetIndex={pIndex}
                                    setSubAssetList={false}
                                    setSubAssetLoading={(e) => {
                                      setListingHelper((prev) =>
                                        prev.map((item, index) =>
                                          index === pIndex
                                            ? {
                                                ...item,
                                                sub_asset: {
                                                  ...item.sub_asset,
                                                  loading: e,
                                                },
                                              }
                                            : item,
                                        ),
                                      );
                                    }} // Control loading state
                                    onClear={() => {
                                      setFieldValue(
                                        `receipts.${pIndex}.sub_asset_id`,
                                        "",
                                      );
                                      setFieldValue(
                                        `receipts.${pIndex}.contract_id`,
                                        "",
                                      );
                                      // setTimeout(() => {
                                      //   setTouched(
                                      //     {
                                      //       [`receipts.${pIndex}.sub_asset_id`]: true,
                                      //     },
                                      //     true
                                      //   );
                                      //   validateField(
                                      //     `receipts.${pIndex}.sub_asset_id`
                                      //   );
                                      // }, 0);
                                      setListingHelper((prev) =>
                                        prev.map((item, index) =>
                                          index === pIndex
                                            ? {
                                                ...item,
                                                contract: {
                                                  ...item.contract,
                                                  listing: [],
                                                },
                                              }
                                            : item,
                                        ),
                                      );

                                      setFieldValue(
                                        `receipts.${pIndex}.asset_id`,
                                        "",
                                      );
                                      setListingHelper((prev) =>
                                        prev.map((item, index) =>
                                          index === pIndex
                                            ? {
                                                ...item,
                                                asset: {
                                                  ...item.asset,
                                                  listing: [],
                                                },
                                              }
                                            : item,
                                        ),
                                      );

                                      setFieldValue(
                                        `receipts.${pIndex}.vendor_id`,
                                        "",
                                      );
                                    }}
                                    className={
                                      errors?.receipts?.[pIndex]
                                        ?.sub_asset_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    loading={
                                      listingHelper?.[pIndex]?.sub_asset
                                        ?.loading
                                    }
                                  />
                                  {listingHelper?.[pIndex]?.sub_asset
                                    ?.loading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              ) : (
                                <div className="relative mt-2">
                                  <Input
                                    placeholder={"Select Sub Asset"}
                                    disabled={true}
                                  />
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="asset_id">
                                <CustomLabelText
                                  labelText={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "assets",
                                    "Asset",
                                  )}
                                  errorField={
                                    errors?.receipts?.[pIndex]?.asset_id
                                  }
                                  required={true}
                                />
                              </Label>
                              <div className="mt-2 relative">
                                <AssetSelect
                                  trustId={trustId}
                                  vendorId={
                                    receipt?.vendor_id ? receipt?.vendor_id : ""
                                  }
                                  frameworkData={
                                    listingHelper?.[pIndex]?.asset?.listing
                                      ? listingHelper?.[pIndex]?.asset?.listing
                                      : []
                                  }
                                  optionType={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "assets",
                                    "Asset",
                                  )}
                                  handleSelect={(e) => {
                                    setFieldValue(
                                      `receipts.${pIndex}.asset_id`,
                                      e,
                                    );
                                    setFieldValue(
                                      `receipts.${pIndex}.sub_asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `receipts.${pIndex}.contract_id`,
                                      "",
                                    );
                                    // setTimeout(() => {
                                    //   setTouched(
                                    //     {
                                    //       [`receipts.${pIndex}.asset_id`]: true,
                                    //     },
                                    //     true
                                    //   );
                                    //   validateField(
                                    //     `receipts.${pIndex}.asset_id`
                                    //   );
                                    //   setTouched(
                                    //     {
                                    //       [`receipts.${pIndex}.sub_asset_id`]: true,
                                    //     },
                                    //     true
                                    //   );
                                    //   validateField(
                                    //     `receipts.${pIndex}.sub_asset_id`
                                    //   );
                                    // }, 0);
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              sub_asset: {
                                                ...item.sub_asset,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }}
                                  name="asset_id"
                                  // disabled={values?.vendor_id ? false : true}
                                  disabled={true}
                                  initialValue={
                                    receipt?.asset_id ? receipt?.asset_id : ""
                                  }
                                  notUsingState={true}
                                  setAssetList={false}
                                  setListingHelper={setListingHelper}
                                  targetIndex={pIndex}
                                  setAssetLoading={(e) =>
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              asset: {
                                                ...item.asset,
                                                loading: e,
                                              },
                                            }
                                          : item,
                                      ),
                                    )
                                  }
                                  onClear={() => {
                                    setFieldValue(
                                      `receipts.${pIndex}.asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `receipts.${pIndex}.sub_asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `receipts.${pIndex}.contract_id`,
                                      "",
                                    );

                                    // setTimeout(() => {
                                    //   setTouched(
                                    //     {
                                    //       [`receipts.${pIndex}.asset_id`]: true,
                                    //     },
                                    //     true
                                    //   );
                                    //   validateField(
                                    //     `receipts.${pIndex}.asset_id`
                                    //   );
                                    //   setTouched(
                                    //     {
                                    //       [`receipts.${pIndex}.sub_asset_id`]: true,
                                    //     },
                                    //     true
                                    //   );
                                    //   validateField(
                                    //     `receipts.${pIndex}.sub_asset_id`
                                    //   );
                                    // }, 0);
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              sub_asset: {
                                                ...item.sub_asset,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }}
                                  className={
                                    errors?.receipts?.[pIndex]?.asset_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  loading={listingHelper?.[0]?.asset?.loading}
                                />
                                {listingHelper?.[pIndex]?.asset?.loading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="vendor_id">
                                <CustomLabelText
                                  labelText={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "vendors",
                                    "Vendor",
                                  )}
                                  errorField={
                                    errors?.receipts?.[pIndex]?.vendor_id
                                  }
                                  // errorField={
                                  //   vendorListing?.find(
                                  //     (item) =>
                                  //       item.value === receipt?.vendor_id
                                  //   )?.bank_id
                                  //     ? ""
                                  //     : values?.refund === false
                                  //     ? "Vendor bank details required. Please enter the vendor’s bank details in the vendor edit section."
                                  //     : ""
                                  // }
                                  required={true}
                                />
                              </Label>
                              <div className="relative mt-2">
                                <VendorSelect
                                  trustId={trustId}
                                  frameworkData={vendorListing} // List of vendors
                                  subAssetId={
                                    receipt?.sub_asset_id
                                      ? receipt?.sub_asset_id
                                      : ""
                                  }
                                  optionType={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "vendors",
                                    "Vendor",
                                  )}
                                  handleSelect={(e) => {
                                    setFieldValue(
                                      `receipts.${pIndex}.vendor_id`,
                                      e,
                                    );
                                    setFieldValue(
                                      `receipts.${pIndex}.asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `receipts.${pIndex}.sub_asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `receipts.${pIndex}.contract_id`,
                                      "",
                                    );

                                    // setTimeout(() => {
                                    //   setTouched(
                                    //     {
                                    //       [`receipts.${pIndex}.vendor_id`]: true,
                                    //     },
                                    //     true
                                    //   );
                                    //   validateField(
                                    //     `receipts.${pIndex}.vendor_id`
                                    //   );
                                    //   setTouched(
                                    //     {
                                    //       [`receipts.${pIndex}.asset_id`]: true,
                                    //     },
                                    //     true
                                    //   );
                                    //   validateField(
                                    //     `receipts.${pIndex}.asset_id`
                                    //   );
                                    //   setTouched(
                                    //     {
                                    //       [`receipts.${pIndex}.sub_asset_id`]: true,
                                    //     },
                                    //     true
                                    //   );
                                    //   validateField(
                                    //     `receipts.${pIndex}.sub_asset_id`
                                    //   );
                                    // }, 0);

                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              asset: {
                                                ...item.asset,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );

                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              sub_asset: {
                                                ...item.sub_asset,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );

                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }}
                                  name="vendor_id"
                                  // disabled={false}
                                  disabled={true}
                                  initialValue={
                                    receipt?.vendor_id ? receipt?.vendor_id : ""
                                  }
                                  setVendorList={setVendorList} // Update vendor list as new data loads
                                  setVendorLoading={setVendorLoading} // Control loading state
                                  onClear={() => {
                                    setFieldValue(
                                      `receipts.${pIndex}.vendor_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `receipts.${pIndex}.asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `receipts.${pIndex}.sub_asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `receipts.${pIndex}.contract_id`,
                                      "",
                                    );

                                    // setTimeout(() => {
                                    //   setTouched(
                                    //     {
                                    //       [`receipts.${pIndex}.vendor_id`]: true,
                                    //     },
                                    //     true
                                    //   );
                                    //   validateField(
                                    //     `receipts.${pIndex}.vendor_id`
                                    //   );
                                    //   setTouched(
                                    //     {
                                    //       [`receipts.${pIndex}.asset_id`]: true,
                                    //     },
                                    //     true
                                    //   );
                                    //   validateField(
                                    //     `receipts.${pIndex}.asset_id`
                                    //   );
                                    //   setTouched(
                                    //     {
                                    //       [`receipts.${pIndex}.sub_asset_id`]: true,
                                    //     },
                                    //     true
                                    //   );
                                    //   validateField(
                                    //     `receipts.${pIndex}.sub_asset_id`
                                    //   );
                                    // }, 0);

                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              asset: {
                                                ...item.asset,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );

                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              sub_asset: {
                                                ...item.sub_asset,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );

                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }}
                                  // className={
                                  //   values?.refund === false &&
                                  //   !vendorListing?.find(
                                  //     (item) =>
                                  //       item.value === receipt?.vendor_id
                                  //   )?.bank_id &&
                                  //   `focus-visible:ring-red-500 border-red-500`
                                  // }
                                  className={
                                    errors?.receipts?.[pIndex]?.vendor_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  loading={vendorLoading}
                                />
                                {vendorLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* <div className="grid gap-2">
                    <div className="min-w-0">
                      <Label htmlFor="asset_id">
                        <CustomLabelText
                          labelText="Sub Asset"
                          errorField={errors?.sub_asset_id}
                          required={true}
                        />
                      </Label>
                      <div className="relative mt-2">
                        <SubAssetSelect
                          trustId={trustId}
                          assetId={values?.asset_id ? values?.asset_id : ""}
                          contactId={""}
                          frameworkData={
                            listingHelper[0]?.sub_asset?.listing
                              ? listingHelper[0]?.sub_asset?.listing
                              : []
                          } // List of vendors
                          optionType="SubAsset"
                          handleSelect={(e) => {
                            let subAssetData =
                              listingHelper[0]?.sub_asset?.listing?.find(
                                (item) => item.value === e
                              );
                            setFieldValue(
                              `tax_percentage`,
                              subAssetData?.tax_percentage
                            );
                            setFieldValue(`tax`, subAssetData?.tax_type);
                            setFieldValue(`sub_asset_id`, e);
                            setFieldValue(`contract_id`, "");

                            setTimeout(() => {
                              setTouched({ sub_asset_id: true });
                              validateField("sub_asset_id");
                            }, 0);

                            let totalAmount = values?.receipt_data[0]
                              ?.total_amount
                              ? values?.receipt_data[0]?.total_amount
                              : "";

                            let gst_price = CalculateGST(
                              values?.tax,
                              totalAmount,
                              subAssetData?.tax_percentage
                            );

                            let amount_inc = CalculateAmountExcGST(
                              values?.tax,
                              totalAmount,
                              subAssetData?.tax_percentage
                            );

                            values?.receipt_data?.length > 0 &&
                              setFieldValue(
                                `receipt_data.${0}.total_amount`,
                                totalAmount
                              );

                            values?.receipt_data?.length > 0 &&
                              setFieldValue(
                                `receipt_data.${0}.amount`,
                                amount_inc
                              );

                            values?.receipt_data?.length > 0 &&
                              setFieldValue(
                                `receipt_data.${0}.tax_amount`,
                                gst_price
                              );

                            setListingHelper((prev) =>
                              prev.map((item, index) =>
                                index === 0
                                  ? {
                                      ...item,
                                      contract: {
                                        ...item.contract,
                                        listing: [],
                                      },
                                    }
                                  : item
                              )
                            );
                          }}
                          name="sub_asset_id"
                          disabled={values?.asset_id ? false : true}
                          initialValue={
                            values?.sub_asset_id ? values?.sub_asset_id : ""
                          }
                          setListingHelper={setListingHelper}
                          targetIndex={0}
                          setSubAssetList={false}
                          setSubAssetLoading={(e) => {
                            setListingHelper((prev) =>
                              prev.map((item, index) =>
                                index === 0
                                  ? {
                                      ...item,
                                      sub_asset: {
                                        ...item.sub_asset,
                                        loading: e,
                                      },
                                    }
                                  : item
                              )
                            );
                          }} // Control loading state
                          onClear={() => {
                            setFieldValue(`sub_asset_id`, "");
                            setFieldValue(`contract_id`, "");
                            setTimeout(() => {
                              setTouched({ sub_asset_id: true });
                              validateField("sub_asset_id");
                            }, 0);
                            setListingHelper((prev) =>
                              prev.map((item, index) =>
                                index === 0
                                  ? {
                                      ...item,
                                      contract: {
                                        ...item.contract,
                                        listing: [],
                                      },
                                    }
                                  : item
                              )
                            );
                          }}
                          className={
                            errors?.sub_asset_id &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          loading={listingHelper?.[0]?.sub_asset?.loading}
                        />
                        {listingHelper?.[0]?.sub_asset?.loading && (
                          <span className="absolute top-2 right-2 animate-spin">
                            <Loader2 width={20} height={20} />
                          </span>
                        )}
                      </div>
                    </div>
                  </div> */}

                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="contract_id">
                                <CustomLabelText
                                  labelText="Agreement/Contract"
                                  errorField={
                                    errors?.receipts?.[pIndex]?.contract_id
                                  }
                                />
                              </Label>
                              <div className="relative mt-2">
                                <ContractSelect
                                  trustId={trustId}
                                  subAssetId={
                                    receipt?.sub_asset_id
                                      ? receipt?.sub_asset_id
                                      : ""
                                  }
                                  frameworkData={
                                    listingHelper[pIndex]?.contract?.listing
                                      ? listingHelper[pIndex]?.contract?.listing
                                      : []
                                  } // List of vendors
                                  optionType="Contract"
                                  handleSelect={(e) => {
                                    setFieldValue(
                                      `receipts.${pIndex}.contract_id`,
                                      e,
                                    );
                                  }}
                                  name="contract_id"
                                  disabled={false}
                                  initialValue={
                                    receipt?.contract_id
                                      ? receipt?.contract_id
                                      : ""
                                  }
                                  setListingHelper={setListingHelper}
                                  targetIndex={pIndex}
                                  setContractList={false}
                                  setContractLoading={(e) => {
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                loading: e,
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }} // Control loading state
                                  onClear={() => {
                                    setFieldValue(
                                      `receipts.${pIndex}.contract_id`,
                                      "",
                                    );
                                  }}
                                  className={
                                    errors?.receipts?.[pIndex]?.contract_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  loading={
                                    listingHelper?.[pIndex]?.contract?.loading
                                  }
                                />
                                {listingHelper?.[pIndex]?.contract?.loading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          {receipt?.sub_asset_id && (
                            // listingHelper[0]?.sub_asset?.listing?.find(
                            //   (item) => item.value === values?.sub_asset_id
                            // )?.tax_type === "1" &&

                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="gst">
                                  <CustomLabelText
                                    labelText="GST/VAT Applicable"
                                    errorField={errors?.receipts?.[pIndex]?.tax}
                                    required={false}
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <SearchSelect
                                    frameworks={taxOptions}
                                    optionType={"GST Type"}
                                    handleSelect={(e) => {
                                      setFieldValue(
                                        `receipts.${pIndex}.tax`,
                                        e,
                                      );

                                      let subAssetData = listingHelper[
                                        pIndex
                                      ]?.sub_asset?.listing?.find(
                                        (item) =>
                                          item.value === receipt?.sub_asset_id,
                                      );

                                      let receiptListData =
                                        receipt?.receipt_data;

                                      for (
                                        let i = 0;
                                        i < receiptListData?.length;
                                        i++
                                      ) {
                                        let totalAmount = receipt?.receipt_data[
                                          i
                                        ]?.total_amount
                                          ? receipt?.receipt_data[i]
                                              ?.total_amount
                                          : "";

                                        let gst_price = CalculateGST(
                                          "1",
                                          e,
                                          totalAmount,
                                          subAssetData?.tax_percentage,
                                        );

                                        let amount_inc = CalculateAmountExcGST(
                                          "1",
                                          e,
                                          totalAmount,
                                          subAssetData?.tax_percentage,
                                        );

                                        setFieldValue(
                                          `receipts.${pIndex}.receipt_data.${i}.total_amount`,
                                          totalAmount,
                                        );

                                        setFieldValue(
                                          `receipts.${pIndex}.receipt_data.${i}.amount`,
                                          amount_inc,
                                        );

                                        setFieldValue(
                                          `receipts.${pIndex}.receipt_data.${i}.tax_amount`,
                                          gst_price,
                                        );
                                      }
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.receipts?.[pIndex]?.tax &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    disabled={false}
                                    initialValue={receipt?.tax}
                                  />
                                </div>
                              </div>
                            </div>
                          )}

                          {!LawyerConditon(organizationData) && (
                            <>
                              {" "}
                              <div className="grid gap-2">
                                <div className="min-w-0">
                                  <Label htmlFor="ts_job_id">
                                    <CustomLabelText
                                      labelText="Job/Matter"
                                      errorField={
                                        errors?.receipts?.[pIndex]?.ts_job_id
                                      }
                                    />
                                  </Label>
                                  <div className="relative mt-2">
                                    <JobSelect
                                      trustId={trustId}
                                      frameworkData={
                                        listingHelper[pIndex]?.job?.listing
                                          ? listingHelper[pIndex]?.job?.listing
                                          : []
                                      } // List of vendors
                                      optionType="Job/Matter"
                                      handleSelect={(e) => {
                                        setFieldValue(
                                          `receipts.${pIndex}.ts_job_id`,
                                          e,
                                        );
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  task: {
                                                    ...item.task,
                                                    listing: [],
                                                  },
                                                }
                                              : item,
                                          ),
                                        );
                                      }}
                                      name="ts_job_id"
                                      disabled={false}
                                      initialValue={
                                        receipt?.ts_job_id
                                          ? receipt?.ts_job_id
                                          : ""
                                      }
                                      targetIndex={pIndex}
                                      setListingHelper={setListingHelper}
                                      setJobList={false} // Update vendor list as new data loads
                                      setJobLoading={(e) => {
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  job: {
                                                    ...item.job,
                                                    loading: e,
                                                  },
                                                }
                                              : item,
                                          ),
                                        );
                                      }}
                                      onClear={() => {
                                        setFieldValue(
                                          `receipts.${pIndex}.ts_job_id`,
                                          "",
                                        );

                                        setFieldValue(
                                          `receipts.${pIndex}.ts_task_id`,
                                          "",
                                        );

                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  task: {
                                                    ...item.task,
                                                    listing: [],
                                                  },
                                                }
                                              : item,
                                          ),
                                        );
                                      }}
                                      className={
                                        errors?.receipts?.[pIndex]?.ts_job_id &&
                                        `focus-visible:ring-red-500 border-red-500`
                                      }
                                      loading={
                                        listingHelper?.[pIndex]?.job?.loading
                                      }
                                    />
                                    {listingHelper?.[pIndex]?.job?.loading && (
                                      <span className="absolute top-2 right-2 animate-spin">
                                        <Loader2 width={20} height={20} />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="grid gap-2">
                                <div className="min-w-0">
                                  <Label htmlFor="ts_task_id">
                                    <CustomLabelText
                                      labelText="Task/Milestone"
                                      errorField={
                                        errors?.receipts?.[pIndex]?.ts_task_id
                                      }
                                    />
                                  </Label>
                                  <div className="relative mt-2">
                                    <TaskSelect
                                      trustId={trustId}
                                      jobId={
                                        receipt?.ts_job_id
                                          ? receipt?.ts_job_id
                                          : ""
                                      }
                                      frameworkData={
                                        listingHelper?.[pIndex]?.task?.listing
                                          ? listingHelper?.[pIndex]?.task
                                              ?.listing
                                          : []
                                      } // List of vendors
                                      optionType="Task/Milestone"
                                      handleSelect={(e) => {
                                        setFieldValue(
                                          `receipts.${pIndex}.ts_task_id`,
                                          e,
                                        );
                                      }}
                                      name="ts_task_id"
                                      disabled={!receipt?.ts_job_id}
                                      initialValue={
                                        receipt?.ts_task_id
                                          ? receipt?.ts_task_id
                                          : ""
                                      }
                                      targetIndex={pIndex}
                                      setListingHelper={setListingHelper}
                                      setTaskList={false} // Update vendor list as new data loads
                                      setTaskLoading={(e) => {
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  task: {
                                                    ...item.task,
                                                    loading: e,
                                                  },
                                                }
                                              : item,
                                          ),
                                        );
                                      }} // Control loading state
                                      onClear={() => {
                                        setFieldValue(
                                          `receipts.${pIndex}.ts_task_id`,
                                          "",
                                        );
                                      }}
                                      className={
                                        errors?.receipts?.[pIndex]
                                          ?.ts_task_id &&
                                        `focus-visible:ring-red-500 border-red-500`
                                      }
                                      loading={
                                        listingHelper?.[pIndex]?.task?.loading
                                      }
                                    />
                                    {listingHelper?.[pIndex]?.task?.loading && (
                                      <span className="absolute top-2 right-2 animate-spin">
                                        <Loader2 width={20} height={20} />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>

                        {/* Nested FieldArray: receipt_data */}
                        <FieldArray name={`receipt_data`}>
                          {({ push: pushData, remove: removeData }) => (
                            <>
                              <div className="flex items-center justify-between mt-4">
                                <h5 className="font-medium text-sm">
                                  Receipt Rows
                                </h5>
                                <div className="flex items-center gap-2">
                                  {pIndex + 1 === values?.receipts?.length && (
                                    <Button
                                      type="button"
                                      size="icon"
                                      onClick={() => {
                                        push({
                                          vendor_id: "",
                                          asset_id: "",
                                          sub_asset_id: "",
                                          contract_id: "",
                                          ts_job_id: "",
                                          ts_task_id: "",
                                          receipt_data: [
                                            {
                                              from: fromInitalDate,
                                              to: "",
                                              amount: "",
                                              total_amount: "",
                                              tax_amount: "",
                                              // payment_method: 1,
                                              description: "",
                                            },
                                          ],
                                        });

                                        setListingHelper((pre) => [
                                          ...pre,
                                          {
                                            asset: {
                                              listing: [],
                                              loading: false,
                                            },
                                            sub_asset: {
                                              listing: [],
                                              loading: false,
                                            },
                                            contract: {
                                              listing: [],
                                              loading: false,
                                            },
                                            job: {
                                              listing: [],
                                              loading: false,
                                            },
                                            task: {
                                              listing: [],
                                              loading: false,
                                            },
                                          },
                                        ]);
                                      }}
                                      className="h-6 w-6"
                                    >
                                      <Plus className="h-4 w-4" />
                                    </Button>
                                  )}
                                  {values?.receipts?.length > 1 && (
                                    <>
                                      {pIndex + 1 ===
                                        values?.receipts?.length && (
                                        <span>/</span>
                                      )}
                                      <Button
                                        type="button"
                                        variant="destructive"
                                        size="icon"
                                        onClick={() => {
                                          remove(pIndex);

                                          setListingHelper((prev) =>
                                            prev.filter(
                                              (_, index) => index !== pIndex,
                                            ),
                                          );
                                        }}
                                        className="h-6 w-6"
                                      >
                                        <Trash2 className="h-4 w-4" />
                                      </Button>
                                    </>
                                  )}
                                </div>
                              </div>

                              {receipt?.receipt_data?.length > 0 &&
                                receipt?.receipt_data?.map((data, dIndex) => (
                                  <div className="relative">
                                    {!isDesktop && dIndex !== 0 && (
                                      <hr className="mt-4 border-webPrimary" />
                                    )}
                                    <div
                                      key={dIndex}
                                      className={`grid sm:grid-cols-2 grid-cols-1 gap-4 items-start !mt-4 ${"lg:grid-cols-7"}`}
                                    >
                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText="From"
                                                errorField={
                                                  errors?.receipt_data?.[dIndex]
                                                    ?.from
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText="From"
                                              errorField={
                                                errors?.receipts?.[pIndex]
                                                  ?.receipt_data?.[dIndex]?.from
                                              }
                                            />
                                          </Label>
                                        )}
                                        <DateInputPicker
                                          date={
                                            receipt?.receipt_data?.[dIndex]
                                              ?.from
                                              ? receipt?.receipt_data?.[dIndex]
                                                  ?.from
                                              : ""
                                          }
                                          onSelect={(e) => {
                                            setFieldValue(
                                              `receipts.${pIndex}.receipt_data.${dIndex}.from`,
                                              e,
                                            );
                                          }}
                                          className={""}
                                          inputClassName={"w-full"}
                                          icon={false}
                                          disabledDate={{ after: new Date() }}
                                        />
                                      </div>
                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText="To"
                                                errorField={
                                                  errors?.receipts?.[pIndex]
                                                    ?.receipt_data?.[dIndex]?.to
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText="To"
                                              errorField={
                                                errors?.receipts?.[pIndex]
                                                  ?.receipt_data?.[dIndex]?.to
                                              }
                                            />
                                          </Label>
                                        )}
                                        <DateInputPicker
                                          date={
                                            receipt?.receipt_data?.[dIndex]?.to
                                              ? receipt?.receipt_data?.[dIndex]
                                                  ?.to
                                              : ""
                                          }
                                          onSelect={(e) => {
                                            setFieldValue(
                                              `receipts.${pIndex}.receipt_data.${dIndex}.to`,
                                              e,
                                            );
                                          }}
                                          className={""}
                                          inputClassName={"w-full"}
                                          icon={false}
                                        />
                                      </div>

                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText="Amount (Inc)"
                                                errorField={
                                                  errors?.receipts?.[pIndex]
                                                    ?.receipt_data?.[dIndex]
                                                    ?.total_amount
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText="Amount (Inc)"
                                              errorField={
                                                errors?.receipts?.[pIndex]
                                                  ?.receipt_data?.[dIndex]
                                                  ?.total_amount
                                              }
                                            />
                                          </Label>
                                        )}
                                        <Input
                                          id={`receipts.${pIndex}.receipt_data.${dIndex}.total_amount`}
                                          type="number"
                                          name={`receipts.${pIndex}.receipt_data.${dIndex}.total_amount`}
                                          value={
                                            receipt?.receipt_data?.[dIndex]
                                              ?.total_amount
                                              ? receipt?.receipt_data?.[dIndex]
                                                  ?.total_amount
                                              : ""
                                          }
                                          placeholder="Amount (Inc)"
                                          onChange={(e) => {
                                            setFieldValue(
                                              `receipts.${pIndex}.receipt_data.${dIndex}.total_amount`,
                                              e?.target.value,
                                            );
                                            let totalAmount = e?.target.value
                                              ? e?.target.value
                                              : 0;

                                            let subAssetData = listingHelper[
                                              pIndex
                                            ]?.sub_asset?.listing?.find(
                                              (item) =>
                                                item.value ===
                                                receipt?.sub_asset_id,
                                            );

                                            let gst_price = CalculateGST(
                                              "1",
                                              receipt?.tax,
                                              totalAmount,
                                              subAssetData?.tax_percentage,
                                            );

                                            let amount_inc =
                                              CalculateAmountExcGST(
                                                "1",
                                                receipt?.tax,
                                                totalAmount,
                                                subAssetData?.tax_percentage,
                                              );

                                            setFieldValue(
                                              `receipts.${pIndex}.receipt_data.${dIndex}.total_amount`,
                                              totalAmount,
                                            );

                                            setFieldValue(
                                              `receipts.${pIndex}.receipt_data.${dIndex}.amount`,
                                              amount_inc,
                                            );

                                            setFieldValue(
                                              `receipts.${pIndex}.receipt_data.${dIndex}.tax_amount`,
                                              gst_price,
                                            );
                                          }}
                                          onBlur={handleBlur}
                                          autoComplete="off"
                                          onKeyPress={(e) => {
                                            e.which === 13 &&
                                              e.preventDefault();
                                          }}
                                          onKeyDown={(e) => {
                                            // Block e, E, +, -
                                            if (
                                              ["e", "E", "+", "-"].includes(
                                                e.key,
                                              )
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onInput={(e) => {
                                            // Prevent negative numbers
                                            if (e.target.value < 0) {
                                              e.target.value = 0;
                                            }
                                          }}
                                          className={
                                            errors?.receipts?.[pIndex]
                                              ?.receipt_data?.[dIndex]
                                              ?.total_amount &&
                                            `focus-visible:ring-red-500 border-red-500`
                                          }
                                        />
                                      </div>

                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText="Amount (Exc)"
                                                errorField={
                                                  errors?.receipts?.[pIndex]
                                                    ?.receipt_data?.[dIndex]
                                                    ?.amount
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText="Amount (Exc)"
                                              errorField={
                                                errors?.receipts?.[pIndex]
                                                  ?.receipt_data?.[dIndex]
                                                  ?.amount
                                              }
                                            />
                                          </Label>
                                        )}
                                        <Input
                                          id={`receipts.${pIndex}.receipt_data.${dIndex}.amount`}
                                          type="text"
                                          name={`receipts.${pIndex}.receipt_data.${dIndex}.amount`}
                                          value={
                                            receipt?.receipt_data?.[dIndex]
                                              ?.amount
                                              ? receipt?.receipt_data?.[dIndex]
                                                  ?.amount
                                              : ""
                                          }
                                          placeholder="Amount"
                                          disabled={true}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          autoComplete="off"
                                          onKeyPress={(e) => {
                                            e.which === 13 &&
                                              e.preventDefault();
                                          }}
                                          className={
                                            errors?.receipts?.[pIndex]
                                              ?.receipt_data?.[dIndex]
                                              ?.amount &&
                                            `focus-visible:ring-red-500 border-red-500`
                                          }
                                        />
                                      </div>

                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText={`Tax(${
                                                  receipt?.tax === "1"
                                                    ? receipt?.tax_percentage
                                                      ? receipt?.tax_percentage
                                                      : 0
                                                    : 0
                                                }%)`}
                                                errorField={
                                                  errors?.receipts?.[pIndex]
                                                    ?.receipt_data?.[dIndex]
                                                    ?.tax_amount
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText={`Tax(${
                                                receipt?.tax === "1"
                                                  ? receipt?.tax_percentage
                                                    ? receipt?.tax_percentage
                                                    : 0
                                                  : 0
                                              }%)`}
                                              errorField={
                                                errors?.receipts?.[pIndex]
                                                  ?.ereceipt_data?.[dIndex]
                                                  ?.tax_amount
                                              }
                                            />
                                          </Label>
                                        )}
                                        <Input
                                          id={`receipts.${pIndex}.receipt_data.${dIndex}.tax_amount`}
                                          type="text"
                                          name={`receipts.${pIndex}.receipt_data.${dIndex}.tax_amount`}
                                          value={
                                            receipt?.receipt_data?.[dIndex]
                                              ?.tax_amount
                                              ? receipt?.receipt_data?.[dIndex]
                                                  ?.tax_amount
                                              : "0"
                                          }
                                          placeholder="Tax Amount"
                                          onChange={(e) => {
                                            setFieldValue(
                                              `receipts.${pIndex}.receipt_data.${dIndex}.tax_amount`,
                                              e?.target.value,
                                            );
                                          }}
                                          onBlur={handleBlur}
                                          autoComplete="off"
                                          onKeyPress={(e) => {
                                            e.which === 13 &&
                                              e.preventDefault();
                                          }}
                                          disabled={true}
                                          className={
                                            errors?.receipts?.[pIndex]
                                              ?.receipt_data?.[dIndex]
                                              ?.tax_amount &&
                                            `focus-visible:ring-red-500 border-red-500`
                                          }
                                        />
                                      </div>

                                      {/* <div className="grid gap-2">
                                        <div className="min-w-0">
                                          <Label htmlFor="base_type">
                                            <CustomLabelText
                                              required={false}
                                              labelText="Payment Method"
                                              errorField={
                                                errors?.receipts?.[pIndex]
                                                  ?.receipt_data?.[dIndex]
                                                  ?.payment_method
                                              }
                                            />
                                          </Label>
                                          <div className="relative mt-2">
                                            <SearchSelect
                                              frameworks={paymentMethods}
                                              optionType={"Payment Method"}
                                              handleSelect={(e) => {
                                                setFieldValue(
                                                  `receipts.${pIndex}.receipt_data.${dIndex}.payment_method`,
                                                  e
                                                );
                                              }}
                                              handleBlur={handleBlur}
                                              className={
                                                errors?.receipts?.[pIndex]
                                                  ?.receipt_data?.[dIndex]
                                                  ?.payment_method &&
                                                `focus-visible:ring-red-500 border-red-500`
                                              }
                                              disabled={false}
                                              initialValue={
                                                receipt?.receipt_data?.[dIndex]
                                                  ?.payment_method
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div> */}
                                      <div className="flex gap-2 sm:col-span-2">
                                        <div className="grid gap-2 flex-1">
                                          {isDesktop ? (
                                            dIndex === 0 && (
                                              <Label>
                                                <CustomLabelText
                                                  required={false}
                                                  // labelText="Description"
                                                  labelText={
                                                    LawyerConditon(
                                                      organizationData,
                                                    )
                                                      ? "Matter Description"
                                                      : "Description"
                                                  }
                                                  errorField={
                                                    errors?.receipts?.[pIndex]
                                                      ?.receipt_data?.[dIndex]
                                                      ?.description
                                                  }
                                                />
                                              </Label>
                                            )
                                          ) : (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                // labelText="Description"
                                                labelText={
                                                  LawyerConditon(
                                                    organizationData,
                                                  )
                                                    ? "Matter Description"
                                                    : "Description"
                                                }
                                                errorField={
                                                  errors?.receipts?.[pIndex]
                                                    ?.receipt_data?.[dIndex]
                                                    ?.description
                                                }
                                              />
                                            </Label>
                                          )}
                                          <Textarea
                                            id={`receipts.${pIndex}.receipt_data.${dIndex}.description`}
                                            name={`receipts.${pIndex}.receipt_data.${dIndex}.description`}
                                            value={
                                              receipt?.receipt_data?.[dIndex]
                                                ?.description
                                                ? receipt?.receipt_data?.[
                                                    dIndex
                                                  ]?.description
                                                : ""
                                            }
                                            // placeholder={"Description"}
                                            placeholder={
                                              LawyerConditon(organizationData)
                                                ? "Matter Description"
                                                : "Description"
                                            }
                                            onChange={(e) => {
                                              setFieldValue(
                                                `receipts.${pIndex}.receipt_data.${dIndex}.description`,
                                                e?.target?.value,
                                              );
                                            }}
                                            onBlur={handleBlur}
                                            autoComplete="off"
                                            onKeyPress={(e) => {
                                              e.which === 13 &&
                                                e.preventDefault();
                                            }}
                                            className={
                                              errors?.receipts?.[pIndex]
                                                ?.receipt_data?.[dIndex]
                                                ?.description &&
                                              `focus-visible:ring-red-500 border-red-500`
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </>
                          )}
                        </FieldArray>
                      </div>
                    ))}
                  </>
                )}
              </FieldArray>
            </div>
            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button
                // disabled={!isValid || checkVendorBankDetailsForReceipts(values)}
                disabled={!isValid}
                onClick={(e) => {
                  e?.preventDefault();
                  toggleSendEmailModal();
                }}
              >
                Post
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditReceipt();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
            {sendEmailModal && (
              <Confirmation
                title={"Confirmation!"}
                open={sendEmailModal}
                setOpen={setSendEmailModal}
                toggleShow={() => {
                  toggleSendEmailModal();
                }}
                className="sm:max-w-fit"
                message={`Do you want to email this receipt?`}
                extraButton={true}
                extraButtonAction={() => {
                  toggleSendEmailModal();
                }}
                okAction={async () => {
                  setFieldValue("send_email", 1);
                  await submitForm();
                  toggleSendEmailModal();
                }}
                loading={loading}
                cancelAction={async () => {
                  setFieldValue("send_email", 0);
                  await submitForm();
                  toggleSendEmailModal();
                }}
                popupType={popupType}
              />
            )}
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditReceipt;
